// Where consent must come before analytics cookies: the EEA (the 27 EU
// states plus Iceland, Liechtenstein and Norway), the United Kingdom and
// Switzerland, the regions where Google requires Consent Mode and the
// ePrivacy rules apply. Elsewhere analytics starts at once and Settings
// has the opt-out. When the country is unknown, consent is required: when
// in doubt, ask. Pure; the country comes from `country.ts`.

const EU = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];
const EEA_REST = ['IS', 'LI', 'NO'];
const OTHERS = ['GB', 'CH'];

/** ISO 3166-1 alpha-2 codes, upper case, of the regions where the sheet must show before anything is sent. */
export const CONSENT_REQUIRED: ReadonlySet<string> = new Set([...EU, ...EEA_REST, ...OTHERS]);

/** Whether a visitor from this country must be asked first: true for the set above, case-insensitive, and true for unknown (undefined, empty, or not two letters). */
export function consentRequiredFor(country: string | undefined): boolean {
  if (!country) return true;
  const code = country.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(code)) return true;
  return CONSENT_REQUIRED.has(code);
}
